/*
  Header scripts loaded by sections/header.liquid:
  1. Signed-in avatar of <shopify-account>.
  2. "Accessibility Options" links that open the UserWay panel.

  1. Signed-in avatar

  The avatar is drawn inside the component's open shadow root, which theme CSS
  cannot reach, and Shopify exposes no part or variable for its shadow and
  :before. So the few rules we need are added to the shadow root itself.
*/
(function () {
  const TAG = 'shopify-account';
  const CSS = `
    .account-button__avatar {
      background-color: transparent;
      box-shadow: none;
    }

    .account-button__avatar::before {
      visibility: hidden;
    }
      .account-button__avatar:hover{
       transform:none;
       scale:1.0;
      }
        .account-button__avatar .account-button__avatar-initials {
    font-size: 20px;
    font-family: 'DM Sans' !important;
    color:#2C2E33;
}
       .account-button:hover .account-button__avatar-initials {
    color: #fff;
}

  `;
  const RETRY_MS = 250;
  const MAX_TRIES = 20;

  let sheet;

  function applyTo(element) {
    const root = element.shadowRoot;
    if (!root || root.__jgAvatarStyled) return !!root;

    if ('adoptedStyleSheets' in root) {
      // Survives the component re-rendering its contents (for example after sign-in).
      sheet = sheet || new CSSStyleSheet();
      sheet.replaceSync(CSS);
      root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    } else {
      const style = document.createElement('style');
      style.textContent = CSS;
      root.appendChild(style);
    }

    root.__jgAvatarStyled = true;
    return true;
  }

  function apply(tries) {
    const elements = document.querySelectorAll(TAG);
    const pending = Array.prototype.filter.call(elements, (element) => !applyTo(element));

    // The shadow root appears once the component has connected and rendered.
    if (pending.length && tries < MAX_TRIES) {
      setTimeout(() => apply(tries + 1), RETRY_MS);
    }
  }

  customElements.whenDefined(TAG).then(() => apply(0));
})();

/*
  2. Accessibility Options links

  A link to /pages/accessibility-options, or ending in #accessibility-options,
  opens the UserWay panel (widget.js, loaded in layout/theme.liquid) instead of
  navigating. The href stays, so without JavaScript, or if the widget is
  blocked, the link still goes to that page. One listener on the document
  covers the header, the mobile drawer and the footer menus.
*/
(function () {
  document.addEventListener('click', function (event) {
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    const isOptionsLink =
      href.indexOf('#accessibility-options') !== -1 ||
      /\/pages\/accessibility-options\/?(?:[?#].*)?$/.test(href);
    if (!isOptionsLink) return;

    const icon = document.getElementById('userwayAccessibilityIcon');
    if (window.UserWay && typeof window.UserWay.widgetOpen === 'function') {
      event.preventDefault();
      window.UserWay.widgetOpen();
    } else if (icon) {
      event.preventDefault();
      icon.click();
    }
  });
})();
